<div class="grid-header-container">

  <div class="search-filter-container">
    <ng-content select="[gridHeaderSearchSlot]"></ng-content>
    <!-- Search Input-->
    <mat-form-field
      *ngIf="showSearch"
      class="search-input tl-filter-field tl-filter-field--search"
    >
      <input
        matInput
        type="text"
        placeholder="{{ searchPlaceholder | translate }}"
        (keyup)="onSearch($event)"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <!-- Select dropdown if options provided -->
    <mat-form-field
      *ngIf="selectOptions.length > 0"
      class="select-dropdown tl-filter-field tl-filter-field--select"
    >
      <mat-select
        [(ngModel)]="selectedValue"
        (selectionChange)="onSelectChange($event.value)"
      >
        <mat-option *ngFor="let option of selectOptions" [value]="option.value">
          {{ option.label | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- A page's own filter controls, beside the toggles - for example a single-choice group. -->
    <ng-content select="[gridHeaderFilterSlot]"></ng-content>

    <!-- Toggle buttons if provided -->
    <mat-button-toggle-group
      multiple
      class="smaller-toggle-group tl-filter-toggle-group"
      *ngIf="toggles.length > 0"
    >
      <mat-button-toggle
        *ngFor="let toggle of toggles"
        [checked]="toggle.checked"
        (change)="onToggleChange(toggle.id, $event.source.checked)"
        [matTooltip]="toggle.tooltip || ''"
      >
        {{ toggle.label | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>

    <!-- Legend text if provided. The marker is a real icon rather than a CSS ::before, so the grid
         cell it explains and this legend render the same glyph from the same source. -->
    <span class="inline-flex items-center gap-1" *ngIf="legendText">
      <mat-icon class="tl-icon-sm text-theme">{{ legendIcon }}</mat-icon>
      {{ legendText | translate }}
    </span>
  </div>

  <!-- Action buttons aligned to the right -->
  <div class="action-buttons-container">
    <ng-content select="[gridHeaderActionSlot]"></ng-content>
  </div>

</div>
